import axios from 'axios'

export function myAssess(params) {
    return axios.post('/buyer/2_1/evaluate/my', params).then(res => res.data);
}
export function delAssess(data) {
    return axios.post('/buyer/2_1/evaluate/delete', data).then(res => res.data);
}


export function updateIntactDegree(params) {
    return axios.post('/buyer/2_1/updateIntactDegree', params).then(res => res.data);
}

export function getIntactDegreeProduct(params) {
    return axios.post('/buyer/2_1/getIntactDegreeProduct', params).then(res => res.data);
}

export function getVideoUrl(params) {
    return axios.post('/comm/2_1/live/playUrl', params).then(res => res.data);
}

export function getInviteRecord(params) {
    return axios.post('/teacher/1_0/inviteRecord', params).then(res => res.data);
}

export function doFeedback(params) {
    return axios.post('/feedback/doFeedback', params).then(res => res.data);
}

// export function infoTwo(params) {
//     return axios.post('/store/InfoTwo', params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } }).then(res => res.data);
// }
// export function getCode(params) {
//     return axios.get('/phone/verificationCode', { params }).then(res => res.data);
// }
// export function share(params) {
//     return axios.post('/buyer/2_1/share/app', params).then(res => res.data);
// }

// 投放广告（买家）
export function submitAdSenseApi(params) {
    return axios.post('/buyer/2_1/expert/600/banner/intention/create', params).then(res => res.data);
}

// 投放广告（行家）
export function submitAdSenseExpert(params) {
    return axios.post('/v50/expert/600/banner/intention/create', params).then(res => res.data);
}

// 微信内容校验
export function msgSecCheck(params) {
    return axios.post('/comm/2_1/msgSecCheck', params).then(res => res.data);
}

// 上传base64图片
export function uploadImageBase64(params) {
    return axios.post('/comm/2_1/uploadImageBase64', params).then(res => res.data);
}

// 740 华为云图片校验--临时用的（王冬冬）
export function checkImg(params) {
    return axios.post('/buyer/2_1/expert/740/hw/check/img', params).then(res => res.data);
}

// 上传base64图片
export function uploadImageBase64ByExpert(params) {
    return axios.post('/v50/expert/common/upload/base64', params).then(res => res.data);
}

// 820用户建议反馈
export function doFeedbackByExpert(params) {
    return axios.post('/v50/expert/820/doFeedback', params).then(res => res.data);
}

